import { TextSmall } from '@/components/Texts';
import Link from 'next/link';
import React from 'react';

const rightsData = [
  '-In accordance with Art. 15 GDPR, you may request information about your data processed by us. In particular, you can request information about the processing purposes, the category of data, the categories of recipients to whom your data has been or will be disclosed, the planned storage period, the existence of a right to rectification, erasure, restriction of processing or objection, the existence of a right of complaint, the origin of your data if it was not collected by us, as well as the existence of automated decision-making, including profiling and, if applicable, meaningful information about its details;',
  '-In accordance with Art. 16 GDPR, you have the right to demand the correction of incorrect data or the completion of your data stored by us without delay;',
  '-In accordance with Art. 17 GDPR, you may request the deletion of your data stored by us, unless the processing is necessary for the exercise of the right to freedom of expression and information, for compliance with a legal obligation, for reasons of public interest, or for the assertion, exercise or defense of legal claims;',
  '-In accordance with Art. 18 GDPR, you have the right to demand the restriction of the processing of your data, insofar as the correctness of the data is disputed by you or the processing is unlawful;',
  '-according to Art. 20 GDPR to receive your data that you have provided to us in a structured, common and machine-readable format or to request the transfer to another controller ("data portability");',
  '-You have the right to object to processing in accordance with Article 21 of the GDPR, provided that the processing is based on Article 6 (1) sentence 1 lit. e or lit. f of the GDPR. This is particularly the case if the processing is not necessary for the performance of a contract with you. Unless it is an objection to direct marketing, when exercising such an objection, we ask you to explain the reasons why we should not process your data as we have done. In the event of your justified objection, we will review the merits of the case and either discontinue or adapt the data processing or show you our compelling legitimate grounds on the basis of which we will continue the processing;',
  '-according to Art. 7 (3) GDPR your consent given once (also before the validity of the DS-GVO, i.e. before 25.5.2018) - i.e. your voluntary will made understandable in an informed manner and unambiguously by means of a declaration or other unambiguous confirming act that you agree to the processing of the personal data in question for one or more specific purposes - to be revoked at any time vis-à-vis us, if you have given such consent. This has the consequence that we may no longer continue the data processing based on this consent for the future and',
  '-In accordance with Art. 77 GDPR, you have the right to lodge a complaint about the processing of your personal data in our company with a data protection supervisory authority, such as the data protection supervisory authority responsible for us. As a Dubai company, we do not have a supervisory authority responsible for us. Please find your accurate authority here: https://edpb.europa.eu/about-edpb/about-edpb/members_en.',
];

const YourRights = () => {
  return (
    <>
      <TextSmall fontWeight={700}>(6) Your rights</TextSmall>
      <TextSmall>
        You can assert your rights as a data subject regarding your processed
        personal data at any time by contacting us using the contact details
        provided at the beginning of A.(2), by submitting a customer support
        ticket, email to Diment support@diment.io or a written request to:
      </TextSmall>
      <TextSmall>
        <TextSmall as={'span'} fontWeight={700}>
          Diment
        </TextSmall>
        {/* <br />
        First Floor Almas Tower, Jumeirah Lakes Towers, PO Box 371653 Dubai,
        <br />
        United Arab Emirates
        <br /> */}
        <Link href='mailto:support@diment.io' style={{ color: 'blue' }}>
          support@diment.io
        </Link>
      </TextSmall>
      <TextSmall>
        <TextSmall as={'span'} textDecoration={'underline'}>
          EEA Customers
        </TextSmall>
        , you have the right as a data subject:
      </TextSmall>
      {rightsData.map((item, index) => {
        return (
          <TextSmall pl={8} key={index + 'rights'}>
            {item}
          </TextSmall>
        );
      })}
    </>
  );
};

export default YourRights;
